"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.IconPlus = function (_a) {
    var color = _a.color, style = _a.style;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 256", style: style },
        React.createElement("g", { stroke: color, strokeWidth: "25", fill: "none" },
            React.createElement("path", { d: "M0 127.5h256M127.5 0v256" }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/IconPlus.tsx
// module id = 311
// module chunks = 0